import { render, staticRenderFns } from "./customerInfoBox.vue?vue&type=template&id=119cefb0&"
import script from "./customerInfoBox.vue?vue&type=script&lang=ts&"
export * from "./customerInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports